webpackJsonp([31],{

/***/ 1534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAnimals_vue__ = __webpack_require__(1890);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f410c1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAnimals_vue__ = __webpack_require__(2316);
function injectStyle (ssrContext) {
  __webpack_require__(2310)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f410c1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAnimals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f410c1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAnimals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createChartTheme */
/* unused harmony export chartTooltipColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartThemeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__);



// Wykresy rysują na canvasie, więc tokeny CSS z theme.css do nich nie sięgają —
// motyw SciChart dobieramy osobno, z tego samego rozwiązanego motywu aplikacji.

// Tło jak --surface ciemnego motywu, zamiast grafitowego gradientu paczki,
// żeby wykres nie odcinał się od karty, w której stoi.
var DARK_BACKGROUND = "#172124";

function createChartTheme(resolvedTheme) {
    if (resolvedTheme !== "dark") return new __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__["SciChartJSLightTheme"]();

    var theme = new __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__["SciChartJSDarkv2Theme"]();
    theme.sciChartBackground = DARK_BACKGROUND;
    theme.loadingAnimationBackground = DARK_BACKGROUND;
    return theme;
}

// Dymki rollovera rysowane własnym szablonem SVG mają kolory wpisane w SVG,
// więc applyTheme ich nie zmienia. Jasne to dotychczasowy biały dymek z czarnym
// tekstem, ciemne — kolory wysuwanych paneli z theme.css (--popover-*).
var TOOLTIP_COLORS = {
    light: { background: "#ffffff", border: "#000000", text: "#000000" },
    dark: { background: "#1b2629", border: "#50676d", text: "#e8f1f3" }
};

function chartTooltipColors(resolvedTheme) {
    return resolvedTheme === "dark" ? TOOLTIP_COLORS.dark : TOOLTIP_COLORS.light;
}

// Wykres woła this.chartTheme() przy tworzeniu powierzchni, a mixin
// przemalowuje już narysowane wykresy, gdy użytkownik zmieni motyw.
// Wymaga, żeby komponent trzymał powierzchnię w this.sciChartSurface.
var chartThemeMixin = {
    watch: {
        "$store.getters.resolvedTheme": function $storeGettersResolvedTheme() {
            if (this.sciChartSurface) this.sciChartSurface.applyTheme(this.chartTheme());
        }
    },
    methods: {
        chartTheme: function chartTheme() {
            return createChartTheme(this.$store.getters.resolvedTheme);
        },

        // Szablon dymka woła to przy każdym rysowaniu, więc zmiana motywu działa od razu.
        tooltipColors: function tooltipColors() {
            return chartTooltipColors(this.$store.getters.resolvedTheme);
        }
    }
};

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-simple-spinner v1.2.10 (https://github.com/dzwillia/vue-simple-spinner)
 * (c) 2018 David Z. Williams
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueSimpleSpinner"] = factory();
	else
		root["VueSimpleSpinner"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueSimpleSpinner = undefined;

var _Spinner = __webpack_require__(1);

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined' && window.Vue) {
  Vue.component('vue-simple-spinner', _Spinner2.default);
}

exports.VueSimpleSpinner = _Spinner2.default;
exports.default = _Spinner2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("d89557e4", content, true);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".vue-simple-spinner{transition:all .3s linear}@keyframes vue-simple-spinner-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(6)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var isNumber = function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

exports.default = {
  props: {
    'size': {
      default: 32
    },
    'line-size': {
      type: Number,
      default: 3
    },
    'line-bg-color': {
      type: String,
      default: '#eee'
    },
    'line-fg-color': {
      type: String,
      default: '#2196f3' },
    'speed': {
      type: Number,
      default: 0.8
    },
    'spacing': {
      type: Number,
      default: 4
    },
    'message': {
      type: String,
      default: ''
    },
    'font-size': {
      type: Number,
      default: 13
    },
    'text-fg-color': {
      type: String,
      default: '#555'
    }
  },
  computed: {
    size_px: function size_px() {
      switch (this.size) {
        case 'tiny':
          return 12;
        case 'small':
          return 16;
        case 'medium':
          return 32;
        case 'large':
          return 48;
        case 'big':
          return 64;
        case 'huge':
          return 96;
        case 'massive':
          return 128;
      }

      return isNumber(this.size) ? this.size : 32;
    },
    line_size_px: function line_size_px() {
      switch (this.size) {
        case 'tiny':
          return 1;
        case 'small':
          return 2;
        case 'medium':
          return 3;
        case 'large':
          return 3;
        case 'big':
          return 4;
        case 'huge':
          return 4;
        case 'massive':
          return 5;
      }

      return isNumber(this.lineSize) ? this.lineSize : 4;
    },
    text_margin_top: function text_margin_top() {
      switch (this.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
          return Math.min(Math.max(Math.ceil(this.size_px / 8), 3), 12);
      }

      return isNumber(this.spacing) ? this.spacing : 4;
    },
    text_font_size: function text_font_size() {
      switch (this.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
          return Math.min(Math.max(Math.ceil(this.size_px * 0.4), 11), 32);
      }

      return isNumber(this.fontSize) ? this.fontSize : 13;
    },
    spinner_style: function spinner_style() {
      return {
        'margin': '0 auto',
        'border-radius': '100%',
        'border': this.line_size_px + 'px solid ' + this.lineBgColor,
        'border-top': this.line_size_px + 'px solid ' + this.lineFgColor,
        'width': this.size_px + 'px',
        'height': this.size_px + 'px',
        'animation': 'vue-simple-spinner-spin ' + this.speed + 's linear infinite'
      };
    },
    text_style: function text_style() {
      return {
        'margin-top': this.text_margin_top + 'px',
        'color': this.textFgColor,
        'font-size': this.text_font_size + 'px',
        'text-align': 'center'
      };
    }
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vue-simple-spinner",
    style: (_vm.spinner_style)
  }), _vm._v(" "), (_vm.message.length > 0) ? _c('div', {
    staticClass: "vue-simple-spinner-text",
    style: (_vm.text_style)
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}

/***/ })
/******/ ])["default"];
});

/***/ }),

/***/ 1890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Charts_SciChartAnimalData_vue__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// { "animalNumber": "1366", "transponderNumber": "250269701366", "weight": 664578.3333333334, "isAlarmOff": false, "lastVisit": "2024-06-19T12:19:12.647", "eatenRoughageToday": 23963, "eatenRoughageYesterday": 942, "eatenConcentrateToday": 0, "eatenConcentrateYesterday": 0, "eatenWaterToday": 0, "eatenWaterYesterday": 0, "eatenMilkToday": 0, "eatenMilkYesterday": 0, "visitsRoughageToday": 36, "visitsRoughageYesterday": 1, "visitsConcentrateToday": 0, "visitsConcentrateYesterday": 0, "visitsWaterToday": 0, "visitsWaterYesterday": 0, "visitsMilkToday": 0, "visitsMilkYesterday": 0, "id": "1536852e-f305-4532-a43c-65c599e6b3f9" }

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SciChartAnimalData: __WEBPACK_IMPORTED_MODULE_3__components_Charts_SciChartAnimalData_vue__["a" /* default */],
        Spinner: __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner___default.a
    },
    props: {
        systemId: {},
        systemName: {},
        systemData: {}
    },
    computed: {
        animals: function animals() {
            var _this = this;

            return this.originalAnimals.filter(function (x) {
                return _this.searchResult != '' ? x.animalNumber.startsWith(_this.searchResult) : true;
            }).sort(function (x, y) {
                return x.animalNumber - y.animalNumber;
            });
        },
        systemUnit: function systemUnit() {
            if (this.systemData == null || this.systemData.weightUnit == undefined) return 'kg';

            return ['kg', 'kg', 'lbs'][this.systemData.weightUnit + 1];
        }
    },
    watch: {
        selectedAnimal: function selectedAnimal(newVal, oldVal) {
            var _this2 = this;

            this.weightData = { values: [], labels: [] };
            this.loadingWeight = true;
            this.loadingRoughage = true;
            this.loadingVisits = true;
            this.visitsData = [];
            this.roughageData = [];

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_9" /* getAnimalWeightChart */])(this.systemId, newVal.id).then(function (result) {
                var wData = { values: [], labels: [] };
                for (var i = 0; i < result.values.length; i++) {
                    if (result.values[i] != 0) {
                        wData.values.push((result.values[i] / 1000).toFixed(2));
                        wData.labels.push(result.labels[i]);
                    }
                }
                _this2.weightData = wData;
                _this2.loadingWeight = false;
            });

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_7" /* getAnimalConsumptionChart */])(this.systemId, newVal.id).then(function (result) {
                _this2.roughageData = result;
                _this2.loadingRoughage = false;
            });

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_8" /* getAnimalVisitsChart */])(this.systemId, newVal.id).then(function (result) {
                _this2.visitsData = result;
                _this2.loadingVisits = false;
            });
        }
    },
    data: function data() {
        return {
            // animals: [],
            originalAnimals: [],
            selectedAnimal: null,
            searchResult: '',
            weightData: {},
            roughageData: {},
            visitsData: {},
            loadingAnimals: true,
            loadingWeight: false,
            loadingRoughage: false,
            loadingVisits: false
        };
    },

    methods: {
        getData: function getData() {
            var _this3 = this;

            this.loadingAnimals = true;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_10" /* getAnimals */])(this.systemId).then(function (result) {
                _this3.originalAnimals = result;
                // this.animals = this.originalAnimals;
                _this3.loadingAnimals = false;
            }).catch(function () {
                _this3.loadingAnimals = false;
            });
        },
        mapVisits: function mapVisits(v) {
            return {
                values: v.data.map(function (x) {
                    return x.value;
                }),
                labels: v.data.map(function (x) {
                    return x.date;
                })
            };
        },
        mapConsumption: function mapConsumption(v) {
            console.dir(v);
            return {
                values: v.data.map(function (x) {
                    return x.value / 1000;
                }),
                labels: v.data.map(function (x) {
                    return x.date;
                })
            };
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this4.getData();

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this4);
        }))();
    }
});

/***/ }),

/***/ 1891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_chartTheme__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_Model_Filters_XyLinearTrendFilter__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_Model_Filters_XyLinearTrendFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Charting_Model_Filters_XyLinearTrendFilter__);


//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_10__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: {
        chartData: {
            required: true
        },
        sid: {
            default: 0,
            required: false
        },
        unit: {
            dafault: 'kg',
            required: false
        }
    },
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            xAxis: null,
            yAxis: null
        };
    },

    watch: {
        chartData: function chartData(newVal, oldVal) {
            if (oldVal == null) {
                this.initSciChart(newVal);
            } else {
                this.reload(newVal);
            }
        }
    },
    methods: {
        initSciChart: function initSciChart(data) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, sciChartSurface, wasmContext, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create('scichart-root-herd-weight-' + _this.sid);

                            case 2:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this.chartTheme());

                                _this.xAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                _this.yAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this.yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                _this.xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.01, 0.01);

                                sciChartSurface.xAxes.add(_this.xAxis);
                                sciChartSurface.yAxes.add(_this.yAxis);

                                _this.xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(unixTimestamp).format("YYYY-MM-DD");
                                };

                                _this.populateData(data);

                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this.sciChartSurface.chartModifiers.add(rolloverModifier);

                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        reload: function reload(data) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // if(this.wasmContext == null) {
                                //     this.initSciChart();
                                //     return;
                                // }

                                if (_this2.sciChartSurface.renderableSeries != null) {
                                    _this2.sciChartSurface.renderableSeries.items = [];
                                }

                                _this2.populateData(data);

                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        populateData: function populateData(data) {
            var xValues = data.labels;
            var yValues = data.values;

            var d = [];

            var lineSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](this.wasmContext, {
                stroke: "#0095B2",
                drawNaNAs: __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].PolyLine,
                strokeThickness: 2,
                pointMarker: new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](this.wasmContext, {
                    width: 6,
                    height: 6,
                    strokeThickness: 2,
                    fill: "#0095B230",
                    stroke: "#0095B2"
                })
            });

            if (!(xValues == undefined || xValues == null || xValues.length == 0)) {
                for (var i = 0; i < xValues.length; i++) {
                    d[i] = new Date(__WEBPACK_IMPORTED_MODULE_2_moment___default()(xValues[i])).getTime();
                }

                if (this.unit == '') {
                    yValues = yValues.map(function (x) {
                        return parseInt(x);
                    });
                } else {
                    yValues = yValues.map(function (x) {
                        return parseFloat(parseFloat(x).toFixed(2));
                    });
                }

                lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](this.wasmContext, {
                    xValues: d,
                    yValues: yValues
                });

                lineSeries.strokeThickness = 3;
                lineSeries.rolloverModifierProps.tooltipLabelX = this.labelX ? this.labelX : "X";
                lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                lineSeries.rolloverModifierProps.tooltipTemplate = this.tooltipTemplateMethod;

                // TREND LINE - z jednego pomiaru regresja liczy 0/0 i daje NaN, ktore psuje os Y.
                if (d.length >= 2) {
                    var linearTrendFilter = new __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_Model_Filters_XyLinearTrendFilter__["XyLinearTrendFilter"](new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](this.wasmContext, {
                        xValues: d,
                        yValues: yValues
                    }), { dataSeriesName: this.$t('trendLine') });
                    var filteredLine = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](this.wasmContext, {
                        dataSeries: linearTrendFilter,
                        stroke: "#ff0000",
                        strokeThickness: 2,
                        rolloverModifier: null
                    });
                    filteredLine.rolloverModifierProps.tooltipTemplate = this.trendTemplateMethod;

                    this.sciChartSurface.renderableSeries.add(filteredLine);
                }
                // END OF TREND LINE
            } else {
                lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](this.wasmContext, {
                    xValues: [],
                    yValues: []
                });
            }

            this.sciChartSurface.renderableSeries.add(lineSeries);
            this.sciChartSurface.zoomExtents();
        },
        tooltipTemplateMethod: function tooltipTemplateMethod(id, seriesInfo, rolloverTooltip) {
            var colors = this.tooltipColors();
            // Rozmiar zgłaszany SciChartowi = prostokąt z obrysem. Dawne 200x120
            // odsuwało dymek od punktu w lewo i w górę, poza wąski wykres.
            var width = 152;
            var height = 42;
            rolloverTooltip.updateSize(width, height);

            return "<svg width=\"" + width + "\" height=\"" + height + "\">\n                <rect x=\"1\" y=\"1\" height=\"40\" width=\"150\" rx=\"5\" style=\"stroke-width:1; stroke:" + colors.border + "\" fill=\"" + colors.background + "\"/>\n                <svg>\n                    <text font-size=\"13\" font-family=\"Verdana\" fill=\"" + colors.text + "\">\n                        <tspan x=\"11\" dy=\"1.2em\">" + __WEBPACK_IMPORTED_MODULE_2_moment___default()(Math.floor(seriesInfo.formattedXValue)).format("DD-MM-YYYY") + "</tspan>\n                        <tspan x=\"11\" dy=\"1.2em\">" + (this.unit == '' ? parseInt(seriesInfo.formattedYValue) : parseFloat(seriesInfo.formattedYValue).toFixed(2)) + " " + this.unit + "</tspan>\n                    </text>\n                    <defs>\n                        <filter id=\"f1\" x=\"0\" y=\"0\" width=\"200%\" height=\"200%\">\n                        <feOffset result=\"offOut\" in=\"SourceGraphic\" dx=\"20\" dy=\"20\" />\n                        <feBlend in=\"SourceGraphic\" in2=\"offOut\" mode=\"normal\" />\n                        </filter>\n                    </defs>\n                </svg>\n                </svg>";
        },
        trendTemplateMethod: function trendTemplateMethod(id, seriesInfo, rolloverTooltip) {
            var tooltipColor = rolloverTooltip.tooltipProps.tooltipColor;

            var colors = this.tooltipColors();
            var width = 152;
            var height = 32;
            rolloverTooltip.updateSize(width, height);

            return "<svg width=\"" + width + "\" height=\"" + height + "\">\n                <rect x=\"1\" y=\"1\" height=\"30\" width=\"150\" rx=\"5\" style=\"stroke-width:2; stroke:" + tooltipColor + "\" fill=\"" + colors.background + "\"/>\n                <svg>\n                    <text font-size=\"13\" font-family=\"Verdana\" fill=\"" + colors.text + "\">\n                        <tspan x=\"11\" dy=\"1.2em\">" + (this.unit == '' ? parseInt(seriesInfo.formattedYValue) : seriesInfo.formattedYValue) + " " + this.unit + "</tspan>\n                    </text>\n                    <defs>\n                    <filter id=\"f1\" x=\"0\" y=\"0\" width=\"200%\" height=\"200%\">\n                        <feOffset result=\"offOut\" in=\"SourceGraphic\" dx=\"20\" dy=\"20\" />\n                        <feBlend in=\"SourceGraphic\" in2=\"offOut\" mode=\"normal\" />\n                    </filter>\n                    </defs>\n                </svg>\n            </svg>";
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.initSciChart(this.chartData);

                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1892:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC42ODY5IDEyLjkxNTNMMTguMjM5NyA4Ljk3NTE5QzE3Ljk5ODYgNi44NTA2MyAxNi40MTI1IDUuMTA3MTkgMTQuMjcwMSA0LjM3MzY2VjQuMjY5OTVDMTQuMjcwMSAzLjAxNjI5IDEzLjI1MzggMiAxMi4wMDAyIDJDMTAuNzQ2NSAyIDkuNzMwMjQgMy4wMTYyOSA5LjczMDI0IDQuMjY5OTVWNC4zNzM2NkM5LjQxMTgxIDQuNDgyNjkgOS4xMDU2OCA0LjYxNDAyIDguODE0NDMgNC43NjU2TDE5Ljk5NzkgMTUuOTQ5MUMxOS45Nzg3IDE1LjU4MDkgMTkuODM4MiAxNS4yMDc4IDE5LjU1MjQgMTQuODcyMUMxOS4wNjY3IDE0LjMwMTYgMTguNzY3NCAxMy42MjQ5IDE4LjY4NjkgMTIuOTE1M1pNNi4yMjMgMThIMTYuOTg4MkwyMC41MTg1IDIxLjUzMDNDMjAuODExNCAyMS44MjMyIDIxLjI4NjMgMjEuODIzMiAyMS41NzkyIDIxLjUzMDNDMjEuODcyMSAyMS4yMzc0IDIxLjg3MjEgMjAuNzYyNiAyMS41NzkyIDIwLjQ2OTdMMy41NzkxNiAyLjQ2OTY3QzMuMjg2MjYgMi4xNzY3OCAyLjgxMTM5IDIuMTc2NzggMi41MTg1IDIuNDY5NjdDMi4yMjU2MSAyLjc2MjU2IDIuMjI1NjEgMy4yMzc0NCAyLjUxODUgMy41MzAzM0w2LjI2ODg5IDcuMjgwNzJDNi4wMDQwNyA3LjgwNTcyIDUuODI4NzQgOC4zNzUyNiA1Ljc2MDY1IDguOTc1MTlMNS4zMTM0NiAxMi45MTUzQzUuMjMyOTIgMTMuNjI0OSA0LjkzMzYyIDE0LjMwMTYgNC40NDc5NyAxNC44NzIxQzMuMzUwOTQgMTYuMTYwOSA0LjM5NDYyIDE4IDYuMjIzIDE4Wk0xNC45NzI0IDIwLjA3MTVDMTQuNTE1IDIxLjE5OTIgMTMuMzU2OCAyMiAxMi4wMDAyIDIyQzEwLjY0MzcgMjIgOS40ODU1IDIxLjE5OTIgOS4wMjgxNCAyMC4wNzE1QzkuMDA5MDcgMjAuMDI0NSA5LjAwMDI0IDE5Ljk3NCA5LjAwMDI0IDE5LjkyMzNDOS4wMDAyNCAxOS42ODk1IDkuMTg5NzYgMTkuNSA5LjQyMzUzIDE5LjVIMTQuNTc3QzE0LjgxMDcgMTkuNSAxNS4wMDAyIDE5LjY4OTUgMTUuMDAwMiAxOS45MjMzQzE1LjAwMDIgMTkuOTc0IDE0Ljk5MTQgMjAuMDI0NSAxNC45NzI0IDIwLjA3MTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 2310:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2311);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("727fd95b", content, true, {});

/***/ }),

/***/ 2311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".animal-card[data-v-6f410c1a]{color:#fff;padding:5px 10px;margin:5px 10px;background:#414f51;border:1px solid #30383a;border-radius:5px;-webkit-transition-duration:.5s;transition-duration:.5s}.animal-card[data-v-6f410c1a]:hover{background:#30383a}.animal-scroll[data-v-6f410c1a]{max-height:calc(100vh - 100px);overflow:auto}.details-card[data-v-6f410c1a]{width:98%}.details-card[data-v-6f410c1a],.herd-card[data-v-6f410c1a]{color:#fff;padding:5px 10px;margin:5px 10px;background:#414f51;border:1px solid #30383a;border-radius:5px}.herd-card[data-v-6f410c1a]{-webkit-transition-duration:.5s;transition-duration:.5s}.skeleton-card[data-v-6f410c1a]{cursor:default}.skeleton-card[data-v-6f410c1a]:hover{background:#414f51}.skeleton-line[data-v-6f410c1a]{height:14px;margin:8px 0;border-radius:4px;background:-webkit-gradient(linear,left top,right top,color-stop(25%,#4d5b5d),color-stop(37%,#5c6b6d),color-stop(63%,#4d5b5d));background:linear-gradient(90deg,#4d5b5d 25%,#5c6b6d 37%,#4d5b5d 63%);background-size:400% 100%;-webkit-animation:skeleton-loading-data-v-6f410c1a 1.4s ease infinite;animation:skeleton-loading-data-v-6f410c1a 1.4s ease infinite}@-webkit-keyframes skeleton-loading-data-v-6f410c1a{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes skeleton-loading-data-v-6f410c1a{0%{background-position:100% 50%}to{background-position:0 50%}}.empty-state[data-v-6f410c1a]{color:gray;text-align:center;padding:20px 10px;font-size:14px}.placeholder-panel[data-v-6f410c1a]{width:82%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:gray;font-size:16px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemAnimals.vue"],"names":[],"mappings":"AACA,8BACI,WAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,+BAAgC,AAChC,aAAe,CAClB,AACD,+BAOI,SAAW,CACd,AACD,2DARI,WAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,yBAA0B,AAC1B,iBAAmB,CAYtB,AATD,4BAOI,gCAAkC,AAC1B,uBAA0B,CACrC,AAGD,gCACI,cAAgB,CACnB,AACD,sCACI,kBAAoB,CACvB,AACD,gCACI,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,+HAAwI,AACxI,sEAA0E,AAC1E,0BAA2B,AAC3B,sEAAuE,AAC/D,6DAA+D,CAC1E,AACD,oDACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AACD,4CACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AAGD,8BACI,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,cAAgB,CACnB,AAGD,oCACI,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAY,AACZ,cAAgB,CACnB","file":"SystemAnimals.vue","sourcesContent":["\n.animal-card[data-v-6f410c1a] {\n    color: white;\n    padding: 5px 10px;\n    margin: 5px 10px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    -webkit-transition-duration: 0.5s;\n            transition-duration: 0.5s;\n}\n.animal-card[data-v-6f410c1a]:hover {\n    background: #30383a;\n}\n.animal-scroll[data-v-6f410c1a] {\n    max-height: calc(100vh - 100px); \n    overflow: auto;\n}\n.details-card[data-v-6f410c1a] {\n    color: white;\n    padding: 5px 10px;\n    margin: 5px 10px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    width: 98%;\n}\n.herd-card[data-v-6f410c1a] {\n    color: white;\n    padding: 5px 10px;\n    margin: 5px 10px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    -webkit-transition-duration: 0.5s;\n            transition-duration: 0.5s;\n}\n\n/* Skeleton — puste karty podczas ładowania listy zwierząt */\n.skeleton-card[data-v-6f410c1a] {\n    cursor: default;\n}\n.skeleton-card[data-v-6f410c1a]:hover {\n    background: #414F51;\n}\n.skeleton-line[data-v-6f410c1a] {\n    height: 14px;\n    margin: 8px 0;\n    border-radius: 4px;\n    background: -webkit-gradient(linear, left top, right top, color-stop(25%, #4d5b5d), color-stop(37%, #5c6b6d), color-stop(63%, #4d5b5d));\n    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);\n    background-size: 400% 100%;\n    -webkit-animation: skeleton-loading-data-v-6f410c1a 1.4s ease infinite;\n            animation: skeleton-loading-data-v-6f410c1a 1.4s ease infinite;\n}\n@-webkit-keyframes skeleton-loading-data-v-6f410c1a {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n@keyframes skeleton-loading-data-v-6f410c1a {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n\n/* Stan pusty — brak zwierząt do wyświetlenia */\n.empty-state[data-v-6f410c1a] {\n    color: gray;\n    text-align: center;\n    padding: 20px 10px;\n    font-size: 14px;\n}\n\n/* Placeholder prawego panelu — brak wybranego zwierzęcia */\n.placeholder-panel[data-v-6f410c1a] {\n    width: 82%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    color: gray;\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartAnimalData_vue__ = __webpack_require__(1891);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33869e97_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartAnimalData_vue__ = __webpack_require__(2315);
function injectStyle (ssrContext) {
  __webpack_require__(2313)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33869e97"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartAnimalData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33869e97_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartAnimalData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2313:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2314);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("d7e8580e", content, true, {});

/***/ }),

/***/ 2314:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SciChartAnimalData.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal"},[_c('div',{staticStyle:{"width":"100%","margin-right":"10px"},attrs:{"id":'scichart-root-herd-weight-'+_vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[_c('div',{staticStyle:{"width":"18%","min-width":"250px","margin-right":"10px"}},[_c('div',{staticClass:"horizontal",staticStyle:{"margin":"5px 10px"}},[_c('img',{staticStyle:{"margin":"5px"},attrs:{"src":__webpack_require__(2317)}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchResult),expression:"searchResult"}],staticStyle:{"width":"100%","border":"1px solid #414F51","border-radius":"5px"},attrs:{"type":"number","step":"1"},domProps:{"value":(_vm.searchResult)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchResult=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"animal-scroll"},[(_vm.loadingAnimals)?_vm._l((6),function(n){return _c('div',{key:'skeleton-' + n,staticClass:"animal-card skeleton-card"},[_c('div',{staticClass:"skeleton-line",staticStyle:{"width":"40%"}}),_vm._v(" "),_c('div',{staticClass:"skeleton-line",staticStyle:{"width":"70%"}}),_vm._v(" "),_c('div',{staticClass:"skeleton-line",staticStyle:{"width":"60%"}}),_vm._v(" "),_c('div',{staticClass:"skeleton-line",staticStyle:{"width":"65%"}})])}):(_vm.animals.length == 0)?_c('div',{staticClass:"empty-state"},[_vm._v("\n                "+_vm._s(_vm.$t('No animals to display'))+"\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.animals),function(animal){return _c('div',{key:animal.id},[_c('div',{staticClass:"animal-card",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.selectedAnimal = animal}}},[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-between"}},[_c('div',{staticClass:"horizontal"},[(animal.isAlarmOff)?_c('div',[_c('img',{staticStyle:{"margin-right":"5px","padding":"3px 5px"},attrs:{"src":__webpack_require__(1892)}})]):_vm._e(),_vm._v(" "),_c('h5',[_vm._v(_vm._s(animal.animalNumber))])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"gray"}},[_vm._v(_vm._s(animal.transponderNumber))])]),_vm._v(" "),(_vm.systemData != null && _vm.systemData.hasWeight)?_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"margin-right":"5px","padding":"3px 5px"},attrs:{"src":__webpack_require__(2318)}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","align-self":"center"}},[_vm._v(_vm._s((animal.weight / 1000).toFixed(2))+" "+_vm._s(_vm.systemUnit))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"margin-right":"5px","padding":"3px 5px"},attrs:{"src":__webpack_require__(2319)}}),_vm._v(" "),_c('div',{staticClass:"horizontal"},[_c('span',{staticStyle:{"font-size":"14px","align-self":"center","border-right":"1px solid white","padding-right":"5px"}},[_vm._v("T: "+_vm._s(animal.visitsRoughageToday))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","align-self":"center","padding-left":"5px"}},[_vm._v("Y: "+_vm._s(animal.visitsRoughageYesterday))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"margin-right":"5px","padding":"3px 5px"},attrs:{"src":__webpack_require__(2320)}}),_vm._v(" "),_c('div',{staticClass:"horizontal"},[_c('span',{staticStyle:{"font-size":"14px","align-self":"center","border-right":"1px solid white","padding-right":"5px"}},[_vm._v("T: "+_vm._s((animal.eatenRoughageToday / 1000.0).toFixed(2))+" "+_vm._s(_vm.systemUnit))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","align-self":"center","padding-left":"5px"}},[_vm._v("Y: "+_vm._s((animal.eatenRoughageYesterday / 1000.0).toFixed(2))+" "+_vm._s(_vm.systemUnit))])])])])])})],2)]),_vm._v(" "),(_vm.selectedAnimal == null)?_c('div',{staticClass:"placeholder-panel"},[_c('span',[_vm._v(_vm._s(_vm.$t('Select an animal to see details')))])]):_c('div',{staticStyle:{"width":"82%","max-height":"calc(100vh - 50px)","overflow":"auto"}},[_c('div',{staticClass:"details-card"},[_c('div',{staticStyle:{"justify-content":"space-between"}},[_c('div',{staticClass:"horizontal"},[(_vm.selectedAnimal.isAlarmOff)?_c('div',[_c('img',{staticStyle:{"margin-right":"5px","padding":"3px 5px"},attrs:{"src":__webpack_require__(1892)}})]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.selectedAnimal.animalNumber))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","color":"gray"}},[_vm._v("\n                    "+_vm._s(_vm.$t('Transponder'))+":\n                    "),_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.selectedAnimal.transponderNumber))])]),_vm._v(" "),(_vm.systemData != null && _vm.systemData.hasWeight)?_c('div',{staticStyle:{"font-size":"14px","color":"gray"}},[_vm._v("\n                    "+_vm._s(_vm.$t('Weight'))+":\n                    "),_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s((_vm.selectedAnimal.weight / 1000).toFixed(2))+" "+_vm._s(_vm.systemUnit))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","color":"gray"}},[_vm._v("\n                    "+_vm._s(_vm.$t('LastVisit'))+":\n                    "),_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.moment(_vm.selectedAnimal.lastVisit).format('YYYY-MM-DD HH:mm:ss')))])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"grid","grid-template-rows":"auto","grid-template-columns":"50% 50%"}},[(_vm.systemData != null && _vm.systemData.hasWeight)?_c('div',{staticClass:"herd-card"},[_c('h5',[_vm._v(_vm._s(_vm.$t('Weight')))]),_vm._v(" "),(!_vm.loadingWeight)?_c('sci-chart-animal-data',{staticStyle:{"position":"relative"},attrs:{"sid":'weight-' + _vm.selectedAnimal.id,"chartData":_vm.weightData,"unit":_vm.systemUnit}}):_c('Spinner',{staticStyle:{"width":"100%","position":"relative"}})],1):_vm._e(),_vm._v(" "),(_vm.loadingRoughage)?_c('div',{staticClass:"herd-card"},[_c('h5',[_vm._v(_vm._s(_vm.$t('Feeding')))]),_vm._v(" "),_c('Spinner',{staticStyle:{"width":"100%","position":"relative"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.roughageData),function(roughageType){return _c('div',{key:roughageType.label,staticClass:"herd-card"},[_c('h5',[_vm._v(_vm._s(roughageType.label)+" "+_vm._s(_vm.$t('Feeding')))]),_vm._v(" "),_c('sci-chart-animal-data',{staticStyle:{"position":"relative"},attrs:{"sid":'roughage-' + _vm.selectedAnimal.id,"chartData":_vm.mapConsumption(roughageType),"unit":_vm.systemUnit}})],1)}),_vm._v(" "),(_vm.loadingVisits)?_c('div',{staticClass:"herd-card"},[_c('h5',[_vm._v(_vm._s(_vm.$t('Visits')))]),_vm._v(" "),_c('Spinner',{staticStyle:{"width":"100%","position":"relative"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.visitsData),function(visitsType){return _c('div',{key:visitsType.label,staticClass:"herd-card"},[_c('h5',[_vm._v(_vm._s(visitsType.label)+" "+_vm._s(_vm.$t('Visits')))]),_vm._v(" "),_c('sci-chart-animal-data',{staticStyle:{"position":"relative"},attrs:{"sid":'visit-' + _vm.selectedAnimal.id,"chartData":_vm.mapVisits(visitsType),"unit":''}})],1)})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2317:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSA2QzEzLjc2MTQgNiAxNiA4LjIzODU4IDE2IDExTTE2LjY1ODggMTYuNjU0OUwyMSAyMU0xOSAxMUMxOSAxNS40MTgzIDE1LjQxODMgMTkgMTEgMTlDNi41ODE3MiAxOSAzIDE1LjQxODMgMyAxMUMzIDYuNTgxNzIgNi41ODE3MiAzIDExIDNDMTUuNDE4MyAzIDE5IDYuNTgxNzIgMTkgMTFaIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4="

/***/ }),

/***/ 2318:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 2319:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjgyOTE4IDMuMTA1NTdDOS4xNjc5NiAyLjQyOCA5Ljg2MDQ5IDIgMTAuNjE4IDJIMTMuMzgyQzE0LjEzOTUgMiAxNC44MzIgMi40MjggMTUuMTcwOCAzLjEwNTU3TDE3Ljc2NDIgOC4yOTIzM0wyMi4wMjkgMTAuODUxMkMyMi42MzE0IDExLjIxMjYgMjMgMTEuODYzNyAyMyAxMi41NjYyVjE5LjVDMjMgMjAuNjA0NiAyMi4xMDQ2IDIxLjUgMjEgMjEuNUgzQzEuODk1NDMgMjEuNSAxIDIwLjYwNDYgMSAxOS41VjEyLjU2NjJDMSAxMS44NjM3IDEuMzY4NiAxMS4yMTI3IDEuOTcxMDEgMTAuODUxMkw2LjIzNTggOC4yOTIzM0w4LjgyOTE4IDMuMTA1NTdaTTEzLjM4MiA0TDEwLjYxOCA0TDguMDI0NjYgOS4xODY3NkM3Ljg1NDU1IDkuNTI2OTcgNy41OTA5NiA5LjgxMTYyIDcuMjY0NzkgMTAuMDA3M0wzIDEyLjU2NjJWMTkuNUgyMVYxMi41NjYyTDE2LjczNTIgMTAuMDA3M0MxNi40MDkgOS44MTE2MiAxNi4xNDU0IDkuNTI2OTcgMTUuOTc1MyA5LjE4Njc2TDEzLjM4MiA0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEzIDdDMTMgNy41NTIyOCAxMi41NTIzIDggMTIgOEMxMS40NDc3IDggMTEgNy41NTIyOCAxMSA3QzExIDYuNDQ3NzIgMTEuNDQ3NyA2IDEyIDZDMTIuNTUyMyA2IDEzIDYuNDQ3NzIgMTMgN1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNCAxM0gxM1YxMkMxMyAxMS43MzQ4IDEyLjg5NDYgMTEuNDgwNCAxMi43MDcxIDExLjI5MjlDMTIuNTE5NiAxMS4xMDU0IDEyLjI2NTIgMTEgMTIgMTFDMTEuNzM0OCAxMSAxMS40ODA0IDExLjEwNTQgMTEuMjkyOSAxMS4yOTI5QzExLjEwNTQgMTEuNDgwNCAxMSAxMS43MzQ4IDExIDEyVjEzSDEwQzkuNzM0NzggMTMgOS40ODA0MyAxMy4xMDU0IDkuMjkyODkgMTMuMjkyOUM5LjEwNTM2IDEzLjQ4MDQgOSAxMy43MzQ4IDkgMTRDOSAxNC4yNjUyIDkuMTA1MzYgMTQuNTE5NiA5LjI5Mjg5IDE0LjcwNzFDOS40ODA0MyAxNC44OTQ2IDkuNzM0NzggMTUgMTAgMTVIMTFWMTZDMTEgMTYuMjY1MiAxMS4xMDU0IDE2LjUxOTYgMTEuMjkyOSAxNi43MDcxQzExLjQ4MDQgMTYuODk0NiAxMS43MzQ4IDE3IDEyIDE3QzEyLjI2NTIgMTcgMTIuNTE5NiAxNi44OTQ2IDEyLjcwNzEgMTYuNzA3MUMxMi44OTQ2IDE2LjUxOTYgMTMgMTYuMjY1MiAxMyAxNlYxNUgxNEMxNC4yNjUyIDE1IDE0LjUxOTYgMTQuODk0NiAxNC43MDcxIDE0LjcwNzFDMTQuODk0NiAxNC41MTk2IDE1IDE0LjI2NTIgMTUgMTRDMTUgMTMuNzM0OCAxNC44OTQ2IDEzLjQ4MDQgMTQuNzA3MSAxMy4yOTI5QzE0LjUxOTYgMTMuMTA1NCAxNC4yNjUyIDEzIDE0IDEzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 2320:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.e2bce93ebd2fe6befe39.js